import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import { API_PATH } from '../../../constants';
import axios from 'axios';
import { setupAxiosRetryInterceptor, handleError } from '../../../utils/axios-retry';

const options = {
  name: 'pagerTemplates',
  baseType: 'PAGER_TEMPLATES',
  apiEndpoint: 'pagers/templates'
};

const defaultOperations = createMetadataAPIOperations(options);

const applyTemplate = (templateId, pagerIds) => () => {
  const url = `${API_PATH}/pagers/templates/${templateId}/apply`;

  const data = { pager_ids: pagerIds };

  return axios
    .post(url, data)
    .then(() => {
      setupAxiosRetryInterceptor();
    })
    .catch(error => {
      handleError(error);
      setupAxiosRetryInterceptor();
    });
};

export default {
  ...defaultOperations,
  applyTemplate
};
